import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {BaseGeneralComponent} from "../../BaseGeneralComponent";
import {MatDialog, MatPaginator, MatSort, MatTableDataSource, PageEvent, Sort} from "@angular/material";
import {Subscription} from "rxjs";
import {Offset} from "../../../models/Offset";
import {ContractualDataModel} from "../../../models/ContractualDataModel";
import {ContractualValuesService} from "../contractual-values/service-contractual-values/contractual-values.service";
import {NumAnnoMeseService} from "../../general-services/service-num-anno-mese/num-anno-mese.service";
import {ContractTypeService} from "../../general-services/service-contract-type/contract-type.service";
import {UsersService} from "../../users/service/users.service";
import {LoaderService} from "../../general-services/service-loader/loader.service";
import {Router} from "@angular/router";
import {GenericArray} from "../../../models/GenericArray";
import {DialogDetailComponent} from "../../general-components/dialog-detail/dialog-detail.component";
import {DialogPriceRangeComponent} from "../../general-components/dialog-price-range/dialog-price-range.component";
import {ProviderModel} from "../../../models/ProviderModel";
import * as toastr from 'toastr';
import {ChargingMethodologyService} from "../../general-services/service-charging-methodology/charging-methodology.service";
import {ChargingMethodologyModel} from "../../../models/ChargingMethodologyModel";

@Component({
  selector: 'app-arc-rrc',
  templateUrl: './arc-rrc.component.html',
  styleUrls: ['./arc-rrc.component.scss']
})
export class ArcRrcComponent extends BaseGeneralComponent implements OnInit, OnChanges, OnDestroy {

  sectionId: string;

  displayedColumns: Array<string>;
  dataSource: any;
  isContractSection: boolean;
  selectedRowIndex: number;
  listData: MatTableDataSource<any>;
  getPageSubscribe: Subscription;
  deleteElementSubscribe: Subscription;

  offset: Offset;
  filter: ContractualDataModel;
  numAnnoMeseData: any;
  contractTypeData: any;
  chargingMethData: any;
  showNewEditDelete: boolean;
  showFilter: boolean;

  @Input() showActions?: boolean;
  @Input() idSelected?: number;
  @Input() inServiceChanges?: boolean;
  @Input() reportSection?: boolean;

  @Output() elementSelected = new EventEmitter();

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(private contractualValuesService: ContractualValuesService,
              private numAnnoMeseService: NumAnnoMeseService,
              private contractTypeService: ContractTypeService,
              private chargingMethService: ChargingMethodologyService,
              private userService: UsersService,
              private loaderService: LoaderService,
              private dialog: MatDialog,
              private router: Router) {
    super();
    this.loaderService.display(true);
    this.showActions = true;
    this.user = JSON.parse(sessionStorage.getItem('user'));
    this.filter = new ContractualDataModel();
    this.sectionId = this.SECTIONS.CONTRACTUAL_DATA;
  }

  ngOnInit() {
    this.isContractSection = this.returnIsContractSection(this.router.url);
    this.showNewEditDelete = !this.checkRole();
    this.showFilter = false;
    this.selectedRowIndex = this.idSelected;
    this.getSessionStorageFilter();

    if (this.showActions === true) {
      if ( this.filter.provider.description === this.PROVIDER_DXC) {
        this.displayedColumns = ['regionDesc',
          'contractTypeDesc', 'localCustomerDesc', 'resourceUnitCod',
          'resourceUnitName', 'size', 'site', 'designServicesDesc', 'unitsCod',
          'currencyDesc', 'chargingMethodology', 'Bmc', 'Bmv', 'Arc', 'Arc2',
          'Rrc', 'Rrc2', 'pxq', 'bandwidth1',
          'bandwidth2', 'actions'];
      }
      else {
        this.displayedColumns = ['regionDesc',
          'contractTypeDesc', 'localCustomerDesc', 'resourceUnitCod',
          'resourceUnitName', 'designServicesDesc', 'unitsCod', 'currencyDesc',
          'chargingMethodology', 'Bmc', 'Bmv', 'Arc', 'Rrc', 'pxq', 'actions'];
      }
    } else {
      this.displayedColumns = ['regionDesc',
        'contractTypeDesc', 'localCustomerDesc', 'resourceUnitCod',
        'resourceUnitName', 'designServicesDesc', 'unitsCod', 'currencyDesc',
        'chargingMethodology', 'Bmc', 'Bmv', 'Arc', 'Rrc', 'pxq'];
      if (this.inServiceChanges) {
        this.displayedColumns = ['regionDesc',
          'localCustomerDesc', 'contractTypeDesc', 'resourceUnitCod', 'resourceUnitName'];
      }
    }

    this.userService.getUserSectionGrant(this.user.id, this.sectionId).subscribe(
      (result: any) => {
        this.setUserGrants(result);
      });
    this.offset = this.setOffsetInSession(this.offset, this.OFFSET_NAME.CONTRACTUAL_VALUES_OFFSET);
    this.init();
  }

  ngOnChanges() {
  }

  init() {
    this.contractTypeService.getListInAllSettings(
      this.contractTypeService.baseUrl,
      this.filter).subscribe(
      (resultContractType: any) => {
        this.contractTypeData = resultContractType;
        if (!this.filter.contractType) {
          this.filter.contractType = this.contractTypeData[0];
        }
        this.numAnnoMeseService.getAllMonth(this.filter.contractType).subscribe(
          (resultYearMonth: any) => {
            this.numAnnoMeseData = resultYearMonth;

            if (!this.filter.numAnnoMese || !BaseGeneralComponent.isNumAnnoMeseInFilterList(this.filter.numAnnoMese, this.numAnnoMeseData)) {
              const numAnnoMese = resultYearMonth[0] ? resultYearMonth[0] : null;
              this.filter.numAnnoMese = numAnnoMese;
            }

            const chargingMethData = new ChargingMethodologyModel(this.CHARGING_METHODOLOGY.ARC_RRC);
            this.filter.chargingMethodology = chargingMethData.value;
            this.filter.chargingMethodologyObject = chargingMethData;

            if (!this.reportSection) {
              this.showFilter = false;
              this.getDataPage(this.offset, this.filter);
            } else {
              this.showFilter = true;
            }
            this.loaderService.display(false);
          }, error => {
            console.log(error);
            this.loaderService.display(false);
          });
      });

  }

  getDataPage(offset: Offset, filter: ContractualDataModel) {
    this.getPageSubscribe = this.contractualValuesService.getPage(offset, filter)
      .subscribe(
        (rFinal: any) => {
          this.dataSource = rFinal.content;
          this.listData = new MatTableDataSource(this.dataSource);
          this.listData.sort = this.sort;
          this.paginator.pageIndex = offset.pageIndex;
          this.paginator.showFirstLastButtons = true;
          this.paginator.length = rFinal.totalElements;
          this.loaderService.display(false);
        });
  }

  openDialog(id: number) {
    if ( this.filter.provider.description === this.PROVIDER_DXC) {
      const contractualData = this.dataSource.find(data => data.id === id) as ContractualDataModel, list: GenericArray[] = [
          {id: 'Month', value: this.toCustomStringAnnoMese(contractualData.numAnnoMese)},
          {id: 'Provider Cod', value: this.toCustomString(contractualData.provider.cod)},
          {id: 'Provider Description', value: this.toCustomString(contractualData.provider.description)},
          {id: 'Region Cod', value: this.toCustomString(contractualData.region.cod)},
          {id: 'Region Description', value: this.toCustomString(contractualData.region.description)},
          {id: 'Local Customer Cod', value: this.toCustomString(contractualData.localCustomer.cod)},
          {id: 'Local Customer Description', value: this.toCustomString(contractualData.localCustomer.description)},
          {id: 'Contract Type Cod', value: this.toCustomString(contractualData.contractType.cod)},
          {id: 'Contract Type Description', value: this.toCustomString(contractualData.contractType.description)},
          {id: 'Resource unit Cod', value: this.toCustomString(contractualData.resourceUnit.cod)},
          {id: 'Resource unit Name', value: this.toCustomString(contractualData.resourceUnit.name)},
          {id: 'SL1 Cod', value: this.toCustomString(contractualData.designServices.cod)},
          {id: 'SL1 Description', value: this.toCustomString(contractualData.designServices.description)},
          {id: 'Units Cod', value: this.toCustomString(contractualData.units ? contractualData.units.cod : null)},
          {id: 'Units Description', value: this.toCustomString(contractualData.units ? contractualData.units.description : null)},
          {id: 'Currency Cod', value: this.toCustomString(contractualData.currency.cod)},
          {id: 'Currency Description', value: this.toCustomString(contractualData.currency.description)},
          {id: 'Charging Methodology', value: this.toCustomString(contractualData.chargingMethodology)},
          {id: 'Bmc', value: this.toCustomString(contractualData.bmc)},
          {id: 'Bmv', value: this.toCustomString(contractualData.bmv)},
          {id: 'Arc', value: this.toCustomString(contractualData.arc)},
          {id: 'Arc 2', value: this.toCustomString(contractualData.arc2)},
          {id: 'Rrc', value: this.toCustomString(contractualData.rrc)},
          {id: 'Rrc 2', value: this.toCustomString(contractualData.rrc2)},
          {id: 'PxQ', value: this.toCustomString(contractualData.pxq)},
          {id: 'Payment', value: this.toCustomString(contractualData.compensationPayment)},
          {id: 'Bandwidth 1', value: this.toCustomString(contractualData.bandwidth1)},
          {id: 'Bandwidth 2', value: this.toCustomString(contractualData.bandwidth2)},
          {id: 'Compensation Payment', value: this.toCustomString(contractualData.compensationPayment)},
          {id: 'Termination Fee', value: this.toCustomString(contractualData.terminationFee)}
        ],
        dialogRef = this.dialog.open(DialogDetailComponent, {
          width: '40%',
          data: {list}
        });
      dialogRef.afterClosed().subscribe(result => {
        // console.log('The dialog was closed');
      });
    } else{
      const contractualData = this.dataSource.find(data => data.id === id) as ContractualDataModel, list: GenericArray[] = [
          {id: 'Month', value: this.toCustomStringAnnoMese(contractualData.numAnnoMese)},
          {id: 'Provider Cod', value: this.toCustomString(contractualData.provider.cod)},
          {id: 'Provider Description', value: this.toCustomString(contractualData.provider.description)},
          {id: 'Region Cod', value: this.toCustomString(contractualData.region.cod)},
          {id: 'Region Description', value: this.toCustomString(contractualData.region.description)},
          {id: 'Local Customer Cod', value: this.toCustomString(contractualData.localCustomer.cod)},
          {id: 'Local Customer Description', value: this.toCustomString(contractualData.localCustomer.description)},
          {id: 'Contract Type Cod', value: this.toCustomString(contractualData.contractType.cod)},
          {id: 'Contract Type Description', value: this.toCustomString(contractualData.contractType.description)},
          {id: 'Resource unit Cod', value: this.toCustomString(contractualData.resourceUnit.cod)},
          {id: 'Resource unit Name', value: this.toCustomString(contractualData.resourceUnit.name)},
          {id: 'SL1 Cod', value: this.toCustomString(contractualData.designServices.cod)},
          {id: 'SL1 Description', value: this.toCustomString(contractualData.designServices.description)},
          {id: 'Units Cod', value: this.toCustomString(contractualData.units ? contractualData.units.cod : null)},
          {id: 'Units Description', value: this.toCustomString(contractualData.units ? contractualData.units.description : null)},
          {id: 'Size Cod', value: contractualData.size ? contractualData.size.cod : 'N.D.'},
          {id: 'Size Description', value: contractualData.size ? contractualData.size.description : 'N.D.'},
          {id: 'Site Cod', value: contractualData.site ? contractualData.site.cod : 'N.D.'},
          {id: 'Site Description', value: contractualData.site ? contractualData.site.description : 'N.D.'},
          {id: 'Currency Cod', value: this.toCustomString(contractualData.currency.cod)},
          {id: 'Currency Description', value: this.toCustomString(contractualData.currency.description)},
          {id: 'Charging Methodology', value: this.toCustomString(contractualData.chargingMethodology)},
          {id: 'Bmc', value: this.toCustomString(contractualData.bmc)},
          {id: 'Bmv', value: this.toCustomString(contractualData.bmv)},
          {id: 'Arc', value: this.toCustomString(contractualData.arc)},
          {id: 'Arc 2', value: this.toCustomString(contractualData.arc2)},
          {id: 'Rrc', value: this.toCustomString(contractualData.rrc)},
          {id: 'Rrc 2', value: this.toCustomString(contractualData.rrc2)},
          {id: 'PxQ', value: this.toCustomString(contractualData.pxq)},
          {id: 'Payment', value: this.toCustomString(contractualData.compensationPayment)},
          {id: 'Bandwidth 1', value: this.toCustomString(contractualData.bandwidth1)},
          {id: 'Bandwidth 2', value: this.toCustomString(contractualData.bandwidth2)},
          {id: 'Compensation Payment', value: this.toCustomString(contractualData.compensationPayment)},
          {id: 'Termination Fee', value: this.toCustomString(contractualData.terminationFee)}
        ],
        dialogRef = this.dialog.open(DialogDetailComponent, {
          width: '40%',
          data: {list}
        });
      dialogRef.afterClosed().subscribe(result => {
        // console.log('The dialog was closed');
      });
    }
  }

  getNext(event: PageEvent) {
    this.loaderService.display(true);
    const tmpOffset = new Offset(event.pageSize, event.pageIndex);
    this.setOffsetInSession(tmpOffset, this.OFFSET_NAME.CONTRACTUAL_VALUES_OFFSET);
    tmpOffset.orderDirection = this.offset.orderDirection;
    tmpOffset.orderField = this.offset.orderField;
    this.offset = tmpOffset;
    this.getDataPage(this.offset, this.filter);
  }

  getDataFiltered(dataFiltered: any) {
    if (this.offset === null || this.offset === undefined) {
      this.offset = new Offset(10, 0);
    }
    this.filter = dataFiltered;
    if (!this.reportSection) {
      this.getDataPage(this.offset, this.filter);
    }
    this.loaderService.display(false);  }

  sortData(sort: Sort) {
    this.loaderService.display(true);
    if ((sort.active !== null || true || sort.active !== '') && (sort.direction !== '' || sort.direction !== null || true)) {
      if (this.offset === null || this.offset === undefined) {
        this.offset = new Offset(10, 0);
      }

      this.offset.orderField = sort.active;
      this.offset.orderDirection = sort.direction;

      this.getDataPage(this.offset, this.filter);
    }

  }

  selectRow(row: any) {
    this.selectedRowIndex = row.id;
    this.elementSelected.emit({ row });
  }

  ngOnDestroy(): void {
    if (this.getPageSubscribe) {
      this.getPageSubscribe.unsubscribe();
    }
    if (this.deleteElementSubscribe) {
      this.deleteElementSubscribe.unsubscribe();
    }
  }

  toggleFilter() {
    this.showFilter = !this.showFilter;
  }

  getSessionStorageFilter() {
    const filter_ = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.ARC_RRC_FILTER));
    this.filter = filter_ ? filter_ : new ContractualDataModel();
    this.filter.provider = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED)) as ProviderModel;
  }
}
